// taxonomy type ids of the fund filters of the investor directory (taxonomy.type), per environment
const fundTaxonomies = {
    development: {
        fundStrategy: 79,
        fundStructure: 78
    },
    production: {
        fundStrategy: 61,
        fundStructure: 62
    }
}
export const FUND_TAXONOMIES = fundTaxonomies[process.env.NODE_ENV];
